const activeScene = (
  state = {
    scene_id: 0,
    layoutNumber: 1,
    title: "",
    navigation: [],
    videos: [],
    text: [],
    audio: [],
    images: [],
    sidebar: false,
    checkpoint: false,
    sidebarText: [],
    sidebarVideos: [],
    sidebarImages: [],
    checkpoints: [],
  },
  action
) => {
  if (action.type === "SET_ACTIVE_SCENE") {
    return action.payload;
  } else {
    return state;
  }
};

export default activeScene;
